export enum ElectronicSignatureSigningType {
  Password = 1,
  Device = 2,
  LoginAndPassword = 3,
  Email = 4
}